import { Controller, useFormContext } from 'react-hook-form'

import { Select } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { castError } from 'modules/expenses/components/expenses/Detail/_newForm/castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps
} from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import withFieldPermissions, {
  WithFieldPermissionsProps
} from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import { BudgetOption } from 'modules/finance/hooks/useBudgets'

const FIELD_NAME = 'budgetId'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  budgetOptions: BudgetOption[]
  loading: boolean
}

const BudgetField = ({ isFieldMandatory, budgetOptions, loading, isFieldReadOnly }: Props) => {
  const {
    control,
    formState: { errors }
  } = useFormContext()

  const options = budgetOptions.map((option) => ({
    label: option.label,
    value: String(option.value)
  }))

  return (
    <Controller
      name={FIELD_NAME}
      control={control}
      render={({ field }) => {
        const parsedValue =
          typeof field.value === 'string' ? Number.parseInt(field.value, 10) : field.value

        return (
          <Select
            label={i18n.t('budgets.forms.external_resource.budget_field.label')}
            placeholder={i18n.t('budgets.forms.external_resource.budget_field.options.empty')}
            showSearchBox
            searchBoxPlaceholder={i18n.t('common.search')}
            searchEmptyMessage={i18n.t(
              'budgets.forms.external_resource.budget_field.search.not_found'
            )}
            options={options}
            value={parsedValue != null ? String(parsedValue) : undefined}
            onChange={(value: string) => {
              const numericValue = Number.parseInt(value, 10)
              field.onChange(isNaN(numericValue) ? null : numericValue)
            }}
            error={castError(errors?.budgetId)}
            required={isFieldMandatory}
            disabled={isFieldReadOnly}
            loading={loading}
            clearable={!isFieldMandatory}
          />
        )
      }}
    />
  )
}

export default withCustomizationFields(withFieldPermissions(BudgetField, FIELD_NAME))
